module.exports = __webpack_public_path__ + "media/images/top/top_xl-0426b4a4af7029a4fa3ca9490c28bd0e.jpg";